import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import CopySchedulers from './CopySchedulers';

const Container = styled.div``;

const Flex = styled.div`
  justify-content: space-between;
  padding: 0.5rem 0rem;
  padding-right: 50%;
`;

const sorter = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
};

const sort = hours => {
  hours.sort((a, b) => {
    const day1 = a.day;
    const day2 = b.day;
    return sorter[day1] - sorter[day2];
  });
  return hours;
};

const MenuSchedulers = ({ hours: hour }) => {
  const hours = sort(hour);

  return (
    <Container>
      <h3 className="has-text-weight-semibold is-size-3">Menu Schedulers</h3>
      <Flex className="is-flex">
        <p className="is-size-4 has-text-weight-semibold">Day</p>
        <p className="is-size-4 has-text-weight-semibold">Time</p>
      </Flex>
      {hours.map(item => (
        <Flex className="is-flex">
          <p className="is-size-4 has-text-weight-semibold">{item.day}</p>
          <div className="is-size-4">
            {Array.isArray(item.option) && item.option.length !== 0 ? (
              <div className="is-flex">
                <div className="is-flex is-flex-direction-column">
                  {item.option.map(option => (
                    <>
                      <ReactTooltip
                        html
                        place="top"
                        type="dark"
                        effect="float"
                        clickable
                      />
                      <div
                        data-tip={`<span>
          <p>start scheduler: ${option.start_event_name}</p>
          <p>end scheduler: ${option.end_event_name}</p>
        </span>`}
                        data-html
                        className="is-size-4 is-uppercase"
                        style={{ cursor: 'pointer' }}
                      >
                        {`${option.start} - ${option.end}`}
                      </div>
                    </>
                  ))}
                </div>

                <div className="ml-2">
                  <CopySchedulers option={item.option} />
                </div>
              </div>
            ) : (
              'No Schedulers/Closed'
            )}
          </div>
        </Flex>
      ))}
    </Container>
  );
};

export default MenuSchedulers;
